import { useState, useEffect } from 'react'

export const useIntersection = (
    element: React.RefObject<Element>,
    rootMargin: string
) => {
    const [isVisible, setState] = useState(true)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setState(entry.isIntersecting)
            },
            { rootMargin }
        )

        if (element?.current) {
            observer.observe(element.current)
        }

        return () => {
            if (element?.current) {
                return observer?.unobserve(element.current)
            }
        }
    }, [])

    return isVisible
}
